import React from 'react'
import { useScrollableContainerStyles } from './styles';
import { tokens } from '@fluentui/react-components';

const ScrollableContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const styles = useScrollableContainerStyles();
  
  return (
    <div 
      className={styles.scrollContainer}
      style={{
        // CSS custom properties for theme colors
        '--track-bg': tokens.colorNeutralBackground2,
        '--thumb-bg': tokens.colorNeutralStroke1,
        '--thumb-hover': tokens.colorNeutralStroke1Hover,
        '--thumb-active': tokens.colorNeutralStroke1Pressed,
      } as React.CSSProperties}
    >
      {children}
    </div>
  );
};

export default ScrollableContainer;
